import { Container } from "react-bootstrap";
import '../home.css'

const CompanyBenefits = () => {

    const revenue = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/home/profit.svg"
    const money = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/home/money.svg"
    const customer = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/home/customer-care.svg"
    const performance = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/home/high-performance.svg"

    return (
        <>
            <section className="company-benefits-section">
                <Container fluid>
                    <div className="text-center mb-4">
                        <h2 className="ft-wt-600 text-uppercase text-white mb-3">Right Technology + Your Business = Exponential Growth</h2>
                        <p className="mb-0 text-white ft-24">If you’re looking to develop a software product to:</p>
                    </div>
                    <div className="contents-wrapper mb-0">
                        <div className="content-item">
                            <img src={revenue} alt="revenue" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Increase Revenue</h5>
                        </div>
                        <div className="content-item">
                            <img src={money} alt="money" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Save money by removing unnecessary costs</h5>
                        </div>
                        <div className="content-item">
                            <img src={customer} alt="customer-care" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Improve your customer’s experience</h5>
                        </div>
                        <div className="content-item">
                            <img src={performance} alt="performance" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Ultimately transform your business and performance</h5>
                        </div>
                    </div>
                    <p className="mb-0 text-white text-center ft-24">Then it’s crucial to have the right, trusted and reliable software partner for your business.</p>
                </Container>
            </section>
        </>
    )
};

export default CompanyBenefits